// extracted by mini-css-extract-plugin
export default {"contactWrapper":"Contact_contactWrapper__hu4Gy","address":"Contact_address__OVcYV","hours":"Contact_hours__9lGN7","telNumber":"Contact_telNumber__pKJ0T"};